// removed by extract-text-webpack-plugin
module.exports = {"links":"_24hE07QZsjjpLdLAtNae1A","link":"_3R2G_URoF-VJL9vGisvn8B"};


//////////////////
// WEBPACK FOOTER
// ./src/PageLinks.css
// module id = 33
// module chunks = 0